import { AppLogo } from 'packages/lib/common-ui/app-shell/app-logo';
import { Breadcrumbs } from 'packages/lib/common-ui/app-shell/breadcrumbs';
import { NavButtons } from 'packages/lib/common-ui/app-shell/nav-buttons';
import {
  appBarActionsId,
  appBarVersionNumId,
} from 'packages/lib/common-ui/app-shell/portals';
import { ProfileMenuButton } from 'packages/lib/common-ui/app-shell/profile-menu-button';
import { gray } from '@ant-design/colors';
import { Layout, Tooltip } from 'antd';
import { FunctionComponent } from 'react';
import { GIT_SHA_SHORT } from 'packages/env';
const { Header } = Layout;

export const APP_HEADER_HEIGHT_PX = 48;
export const APP_HEADER_HEIGHT = '3rem';
export const AppHeader: FunctionComponent<
  React.PropsWithChildren<unknown>
> = () => (
  <Header
    style={{
      background: '#1C164A',
      padding: '0.25rem 0.5rem',
      alignItems: 'center',
      display: 'flex',
      height: APP_HEADER_HEIGHT,
    }}
  >
    <div
      style={{
        marginRight: 'auto',
        alignItems: 'center',
        display: 'flex',
      }}
    >
      <AppLogo />
      <Breadcrumbs />
    </div>
    <div style={{ marginLeft: 'auto' }}>
      <Tooltip title="App Version">
        <span
          id={appBarVersionNumId}
          style={{
            marginLeft: 'auto',
            marginRight: '0.75rem',
            color: gray[2],
          }}
        />
      </Tooltip>
      <Tooltip title="Latest Release Commit Hash">
        <span
          style={{
            marginLeft: 'auto',
            marginRight: '0.75rem',
            color: gray[2],
          }}
        >
          Version: {GIT_SHA_SHORT}
        </span>
      </Tooltip>
    </div>
    <span id={appBarActionsId} />
    <NavButtons />
    <ProfileMenuButton />
  </Header>
);
